<div class="container" *ngIf="isInited" [hidden]="isLoading || !active" (window:resize)="onResize($event)">
    <div class="header-area">
        <div class="filter-area">
            <div class="filter" (click)="changeStatusFilter($event)">
                <div class="filter-label">{{'general.status' | stringLiterals}}:&nbsp;</div>
                <div class="filter-content dropdown-link">{{filterStatus}}</div>
                <tam-context-menu [config]="statusContextMenuConfig"></tam-context-menu>
            </div>
        </div>
        <div class="action-area">
            <smart-icon name="export-excel" (click)="exportToExcel()" class="light download-icon" kendoTooltip
                position="left" title="{{'general.export_to_excel' | stringLiterals}}" *ngIf="isGridView"></smart-icon>
            <smart-icon name="save-layout" kendoTooltip position="left" class="light layout-settings"
                *ngIf="isLayoutSettingBtnVisible()" title="{{'workflow.save_layout_settings' | stringLiterals}}"
                (click)="onSaveLayoutClicked()">
            </smart-icon>
            <smart-icon name="refresh" kendoTooltip position="bottom" class="light refresh"
                title="{{'general.refresh' | stringLiterals}}" (click)="onRefreshClicked()">
            </smart-icon>
            <div class="view-change" (click)="onChangeView($event)">
                <smart-icon *ngIf="isKanbanView" name="kanban" class="light"></smart-icon>
                <smart-icon *ngIf="isGridView" name="grid" class="light"></smart-icon>
            </div>
        </div>
        <tam-context-menu [config]="actionContextMenuConfig"></tam-context-menu>
    </div>
    <div [hidden]="isGridView" class="body-area">
        <div class="group-info-area" kendoTooltip tooltipClass="tooltip-adjust-right">
            <div class="one-group"
                *ngFor="let item of sortedGroupList.slice(firstGroupIndex,lastGroupIndex);index as i">
                <span class="text-ellipsis group-name" [title]="item.name">{{item.name}}</span>
                <span class="group-count">({{groupedInstanceList[i+firstGroupIndex].length}})</span>
            </div>
        </div>
        <div class="data-area">
            <div class="one-group-data"
                *ngFor="let item of sortedGroupList.slice(firstGroupIndex,lastGroupIndex);index as i">
                <div class="data-list-area">
                    <kanban-instance-card class="one-data"
                        *ngFor="let item of groupedInstanceList[i+firstGroupIndex];trackBy:trackByFn;index as itemIndex"
                        [instance]="item" [processDefinition]="processDefinition.definition"
                        [config]="instanceCardConfig" (click)="onSelectInstance($event,item)">
                    </kanban-instance-card>
                </div>
            </div>
            <tam-context-menu [config]="contextMenuConfig"></tam-context-menu>
        </div>
        <div class="arrow-left" *ngIf="firstGroupIndex>0" (click)="lastPage($event)">
            <smart-icon name="arrow-left"></smart-icon>
        </div>
        <div class="arrow-right" *ngIf="lastGroupIndex!==groupCount" (click)="nextPage($event)">
            <smart-icon name="arrow-right"></smart-icon>
        </div>
    </div>
    <div [hidden]="isKanbanView" class="body-area" (mousedown)="onMousedown($event)">
        <aggregational-grid [topGridColumnDefinitions]="columnDefs" [components]="frameworkComponents"
            [topGridOptions]="gridOptions" [topGridGroupDefaultExpanded]="-1"
            [groupRowInnerRenderer]="groupRowInnerRenderer" (cellClicked)="onCellClick($event)"
            [groupRowRendererParams]="groupRowRendererParams" [topGridDataSource]="data" [getRowNodeId]="getRowNodeId"
            (bodyScroll)="onBodyScroll($event)" (columnVisible)="onColumnVisible($event)"
            (columnMoved)="onColumnMoved($event)" (columnPinned)="onColumnPinned($event)"
            (rowGroupOpened)="onRowGroupOpened($event)" (columnResized)="onColumnResized($event)"
            (columnRowGroupChanged)="onColumnRowGroupChanged($event)" (filterChanged)="onFilterChanged()"
            (gridReady)="onGridReady($event)" (rowClicked)="onRowSelected($event)">
        </aggregational-grid>
    </div>
</div>